/**
 * Deterministic stand-ins for `Math.random` where the server and the client must agree
 * (PRNT-5494): a value derived from a seed and a key is the same on both, so gallery placement
 * decided on the server hydrates without a mismatch. FNV-1a over the string, scaled to [0, 1).
 */
export const seededUnit = (seed: string, key: string | number): number => {
  const input = `${seed}:${key}`;
  let hash = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash / 0x100000000;
};

/** A copy of `list` in a seed-determined order; the same seed always gives the same order. */
export const seededShuffle = <T>(list: ReadonlyArray<T>, seed: string): T[] =>
  list
    .map((item, index) => ({ item, rank: seededUnit(seed, index) }))
    .sort((a, b) => a.rank - b.rank)
    .map(({ item }) => item);
